module.exports = __webpack_public_path__ + "img/imgmaoxzt-2.7af7cf27.png";